import { visit } from 'unist-util-visit'
import type { Root } from 'mdast'

/**
 * Turns remark-directive nodes into custom hast elements so react-markdown can
 * render them through its `components` map. A directive like `::nabidka{slug="x"}`
 * becomes a `<nabidka slug="x">` element, mapped to a React component in
 * `ArticleContent`. Attribute values arrive as string props on the component.
 *
 * Authors write directives as:
 *   ::nabidka{slug="krasna-chalupa"}            (block, on its own line)
 *   :kategorie[Zobrazit nabídky]{region="..."}  (inline)
 */
export function remarkDirectives() {
  return (tree: Root) => {
    visit(tree, (node, index, parent) => {
      // Prose like `11:11` or `14:00` parses as a bare text directive named
      // `11` / `00`. A directive with no label and no attributes embeds
      // nothing, so it goes back to being the literal text.
      if (
        node.type === 'textDirective' &&
        node.children.length === 0 &&
        Object.keys(node.attributes ?? {}).length === 0 &&
        parent &&
        index !== undefined
      ) {
        parent.children.splice(index, 1, {
          type: 'text',
          value: `:${node.name}`,
        })
        return index
      }
      if (node.type === 'containerDirective' || node.type === 'leafDirective' || node.type === 'textDirective') {
        const data = node.data ?? (node.data = {})
        data.hName = node.name
        data.hProperties = { ...node.attributes }
      }
      return undefined
    })
  }
}
